
import { defineComponent } from "vue";

export default defineComponent({
  name: "FailedItem",
  props: {
    caption: String,
  },
});
